<div class="sku-panel" *ngIf="selectedSkus.length">
    <div class="sku-panal_container">
      <div class="sku-panel_title">{{ selectedSkus.length }} SKU's selected</div>
    </div>
    
    <div class="sku-panel_devider"></div>
  
    <div class="input-container" *ngIf="!isWalmartAccount">
      <div class="input-container_label">FBA Type:</div>
      <select
        class="input-container_input input-container_input--thin"
        (change)="updateFbaType()"    
        [formControl]="shipmentType"
      >
        <option *ngFor="let type of fbaTypes" [value]="type.id">{{type.name}}</option>
      </select>
    </div>
  </div>